module.exports = __webpack_public_path__ + "img/banner1.b2d0a3c0.png";